import { useEffect, useState, useRef } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {ModifiedToast} from './toaster';
import {Helmet, HelmetProvider} from "react-helmet-async";
import {FormInput} from './formInput';
import PrimaryButton from './primaryButton';
import { useDeleteAccountMutation } from '../services/authApi';
import { toast } from "react-toastify";

const DeleteAccountRequest = () => { 
    const navigate = useNavigate();
    const [ deleteAccount, { isLoading, isError, isSuccess, error:apiError } ] = useDeleteAccountMutation();
    
    const [ data, setData ] = useState({
        name:"",
        email : "",
        mobile : ""
    });
    const handlerChangeSubmit = (e) => {  
        e.preventDefault();
        const { name, value } = e.target;
        setData((prevData) => ({
          ...prevData,
          [name]: value
        }));
    };

    const handleFormSubmit = (e) => {    
   
        e.preventDefault();
        if (data.name == '' || data.email == '' || data.mobile == '') {
            return;
        }            
        deleteAccount({ name:data.name, email:data.email, mobile:data.mobile });     
    };

    const toastId = useRef(null);
    useEffect(() => {
      if (isLoading) {
        toastId.current = toast.loading("Please wait...", {
        position: "top-right",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        autoClose: 2000,
        theme: "colored",
        type: "info"
      });
      }
      if (isSuccess) {
        toast.dismiss( toastId.current);
  
         setTimeout(() => {
          navigate('/');
         
          toast.success(" Your request has been sent successfully.", {
            render: " Your request has been sent successfully.",
                 type: "success",
                 autoClose: 2000,
               isLoading: false
          });
        }, 210);
      }
      if (isError) {
        toast.dismiss( toastId.current);
        const toastMessage = apiError?.data?.message
          ? apiError?.data?.message
          : "Something went wrong";
          toast.error(toastMessage, {
            render: toastMessage,
                 type: "error",
                 autoClose: 3000,
               isLoading: false,
               theme: "colored",
               closeOnClick: true,
               pauseOnHover: true
          });
        
      }
    }, [ isSuccess, isError, isLoading ]);

    return (
        <div className="h-screen flex bg-gray-bg1 w-full">
            <HelmetProvider>
                <Helmet>
                    <title>Simplyenglish AI | Delete Account Request </title>
                </Helmet>
            </HelmetProvider>           
            <ModifiedToast/>
            <div className=" flex align-center h-screen w-full">
                <div className=" w-full bg-white  ">
                    <div
                        className="md:flex align-center justify-between h-full items-center flex-wrap md:flex-nowrap 	">
                        <div className=" md:p-8 p-2 md:w-1/2 w-full relative mx-auto">
                            <div className=" pt-0">
                                <div
                                    className="w-full max-w-lg m-auto bg-white p-8 border shadow-lg rounded-lg ">
                                     <div className="text-center  w-full 	">
                                        <img
                                            src="../images/logo.png"
                                            width="220"
                                            className="mx-auto"
                                        />
                                    </div>
                                    <h1 className="text-xl font-semibold my-6 mb-8 text-center">
                                    Delete Account Request?

                                    </h1>
                                    <div
                                        
                                        className="text-left"
                                        id="loginForm"
                                    >
                                        <div className="parentGroup mb-2">
                                            <label
                                                htmlFor="name"
                                                className="formBlock"
                                            >
                                            Name
                                            </label>
                                          <FormInput inputType="text" inputName="name" inputID="name" handlerChange={(e) => handlerChangeSubmit(e)}
                                          />
                                            <div className="help-block" />
                                        </div>
                                        
                                        <div className="parentGroup mb-2">
                                            <label
                                                htmlFor="email"
                                                className="formBlock"
                                            >
                                            Email
                                            </label>
                                          <FormInput inputType="email" inputName="email" inputID="email" handlerChange={(e) => handlerChangeSubmit(e)}
                                          />
                                            <div className="help-block" />
                                        </div>

                                        <div className="parentGroup mb-2">
                                            <label
                                                htmlFor="mobile"
                                                className="formBlock"
                                            >
                                            Mobile
                                            </label>
                                          <FormInput inputType="mobile" inputName="mobile" inputID="mobile" handlerChange={(e) => handlerChangeSubmit(e)}
                                          />
                                            <div className="help-block" />
                                        </div>
                                        
                                        <div className=" mt-2 text-center">
                                        <small className='mb-2'><span className='text-danger'>*</span>As per your request, we will be deleting your record. If you wish to continue with us in the future, you will need to register again. 
                                        <a href={'https://play.google.com/store/apps/details?id=com.simplyenglish.ai&pcampaignid=web_share'}  target="_blank" rel="noreferrer">
                                        <img
                                        src="./images/playstore.png"
                                        width="270"
                                        className="mx-auto p-2"
                                        />
                                        </a>
                                        </small>
                                       
                                        <PrimaryButton btnText="Submit " onClick={handleFormSubmit} Btnclass="btn save w-full mt-2 mb-6"/>                                         
                                        <p className='text-gray-600 font-medium'><Link to="/login" className='primary-text font-semibold'>Login</Link></p>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                     
                    </div>
                </div>
            </div>
            <ModifiedToast/>
        </div>
    );
};

export default DeleteAccountRequest;